import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { useClickOutside } from '@/js/libs/use-click-outside';
import Icons from '../../Elements/Icons';
import { Input } from '../Input';
import { getTestId } from './helpers';
import { Divider, Link, LinkTooltipWrapper, ToolbarItem } from './styled';
export const LinkTooltip = ({ editor, saveLink, isCreating, placeholder, dataTestId }) => {
    const href = editor.getAttributes('link').href ?? '';
    const [value, setValue] = useState(href);
    const [isEditing, setIsEditing] = useState(false);
    const [wrapperRef, hasClickedOutside] = useClickOutside();
    const handleValueChange = useCallbackRef((e) => {
        setValue(e.target.value);
    });
    const handleKeyUp = useCallbackRef((e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            saveLink(value);
            setIsEditing(false);
        }
    });
    const handleSaveClick = useCallbackRef(() => {
        saveLink(value);
        setIsEditing(false);
    });
    const handleEditClick = useCallbackRef(() => {
        setValue(href);
        setIsEditing(true);
    });
    const handleDeleteClick = useCallbackRef(() => {
        editor.chain().focus().extendMarkRange('link').unsetLink().run();
    });
    useEffect(() => {
        if (hasClickedOutside) {
            // eslint-disable-next-line react-hooks/set-state-in-effect
            setIsEditing(false);
        }
    }, [hasClickedOutside]);
    return (_jsx(LinkTooltipWrapper, { ref: wrapperRef, "data-testid": getTestId('link-tooltip', dataTestId), children: isCreating || isEditing ? (_jsxs(_Fragment, { children: [_jsx(Input, { type: 'text', value: value, onChange: handleValueChange, onKeyUp: handleKeyUp, placeholder: placeholder, 
                    // eslint-disable-next-line jsx-a11y/no-autofocus
                    autoFocus: true, "data-testid": getTestId('link-input', dataTestId) }), _jsx(ToolbarItem, { type: 'button', "$withPadding": true, onClick: handleSaveClick, "data-testid": getTestId('link-save', dataTestId), children: _jsx(Icons.Checkmark, { size: 20 }) })] })) : (_jsxs(_Fragment, { children: [_jsx(Link, { to: href, target: '_blank', "data-testid": getTestId('link-display', dataTestId), children: href }), _jsx(Divider, {}), _jsx(ToolbarItem, { type: 'button', onClick: handleEditClick, "data-testid": getTestId('link-edit', dataTestId), children: _jsx(Icons.Edit, { size: 20 }) }), _jsx(ToolbarItem, { type: 'button', onClick: handleDeleteClick, "data-testid": getTestId('link-delete', dataTestId), children: _jsx(Icons.Delete, { size: 20 }) })] })) }));
};
